import { HttpService } from './http-service'
import type { AuthCookieStore } from '@@/types/types'

export const setNewClientApi = ({
  baseURL,
  showSsrLog = false,
  cookies,
  fetcher,
}: {
  baseURL: string
  showSsrLog?: boolean
  cookies: AuthCookieStore
  fetcher: typeof useCustomFetch
}) => {
  const h = new HttpService({
    cookies,
    baseURL,
    showSsrLog,
    fetcher,
  })

  return {
    clientApi: {
      httpClient: h,
    },
  }
}

export type ClientApi = ReturnType<
  typeof setNewClientApi
>['clientApi']['httpClient']
